import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {
  computed,
} from 'vue';


export default /*#__PURE__*/_defineComponent({
  props: {
  s: {
    type: [String, Number, Object],
    default: null,
  },
  verticalStart: {
    type: Boolean,
    default: false,
  },
  verticalCenter: {
    type: Boolean,
    default: false,
  },
  verticalEnd: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props



const getCollClass = (size: any, prefix: string | null = null) => {
  const parsedSize = parseInt(size, 10);
  let sizeClass;

  if (parsedSize === 13) {
    sizeClass = `col${prefix || ''}`;
  } else if (parsedSize === 0) {
    sizeClass = `col${prefix || ''}-auto`;
  } else {
    sizeClass = `col${prefix || ''}-${parsedSize}`;
  }

  return sizeClass;
};

const classes = computed(() => {
  const classesArr = [];

  if (props.s) {
    if (['number', 'string'].indexOf(typeof props.s) >= 0) {
      classesArr.push(getCollClass(props.s));
    } else if (typeof props.s === 'object') {
      const sizes = props.s as Record<string, number>;

      Object.keys(sizes).forEach((bp: string) => {
        classesArr.push(getCollClass(sizes[bp], bp === 'xs' ? null : `-${bp}`));
      });
    }
  } else {
    classesArr.push('col');
  }

  if (props.verticalCenter) {
    classesArr.push('align-self-center');
  } else if (props.verticalEnd) {
    classesArr.push('align-self-end');
  } else if (props.verticalStart) {
    classesArr.push('align-self-start');
  }

  return classesArr;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(classes))
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})